import React from 'react';
import { Row, Col, Form } from 'react-bootstrap';
import * as intrfce from '../Interfaces';

interface BusinessPurchaseSectionProps {
  isBusinessPurchase: boolean;
  formTaxData: intrfce.iTaxFormData;
  validationErrors: any;
  handleisBusinessPurchaseChange: (e: React.ChangeEvent<HTMLElement> | React.MouseEvent<HTMLButtonElement>) => void;
  setFormTaxData: React.Dispatch<React.SetStateAction<intrfce.iTaxFormData>>;
  t: (key: string) => string;
}

export const BusinessPurchaseSection: React.FC<BusinessPurchaseSectionProps> = ({
  isBusinessPurchase,
  formTaxData,
  validationErrors,
  handleisBusinessPurchaseChange,
  setFormTaxData,
  t
}) => {
  return (
    <>
      <Row
        xs={"auto"}
        md={"auto"}
        className="mb-4"
        id="vatExemption"
        role="region"
        aria-labelledby="vatExemptionHeader"
      >
        <h3
          id="vatExemptionHeader"
          aria-level={3}
          className="vatExemption"
        >
          {t("VAT_EXEMPTION")}
        </h3>
        <Col md={12}>
          <Form.Group className="isBusinessPurchase" controlId="isBusinessPurchase">
            <Form.Check
              type="checkbox"
              name="businessPurchase"
              label={t("IS_BUSINESS_PURCHASE")}
              checked={isBusinessPurchase}
              onChange={handleisBusinessPurchaseChange}
              aria-checked={isBusinessPurchase}
              aria-label={t("IS_BUSINESS_PURCHASE")}
            />
          </Form.Group>
        </Col>
      </Row>
      {isBusinessPurchase && (
        <Row xs={"auto"} md={"auto"} className="mb-4">
          <Col md={6}>
            <Form.Group controlId="companyName">
              <Form.Label className='visually-hidden' htmlFor="companyName">
                {t('COMPANY_NAME')}
              </Form.Label>
              <Form.Control
                id="companyName"
                value={formTaxData.companyName}
                onChange={(e) => {
                  setFormTaxData({ ...formTaxData, companyName: e.target.value });
                }}
                placeholder={t('COMPANY_NAME')}
                aria-invalid={!!validationErrors.companyName}
                aria-describedby={validationErrors.companyName ? "companyNameError" : undefined}
                isInvalid={!!validationErrors.companyName}
              />
              <Form.Control.Feedback type="invalid" id="companyNameError">
                {validationErrors.companyName}
              </Form.Control.Feedback>
            </Form.Group>
          </Col>
          <Col md={6}>
            <Form.Group controlId="vatNo">
              <Form.Label className='visually-hidden' htmlFor="vatNo">
                {t('VAT_NUMBER')}
              </Form.Label>
              <Form.Control
                id="vatNo"
                value={formTaxData.vatNo}
                onChange={(e) => {
                  setFormTaxData({ ...formTaxData, vatNo: e.target.value });
                }}
                placeholder={t('VAT_NUMBER')}
                aria-invalid={!!validationErrors.vatNo}
                aria-describedby={validationErrors.vatNo ? "vatNoError" : undefined}
                isInvalid={!!validationErrors.vatNo}
              />
              <Form.Control.Feedback type="invalid" id="vatNoError">
                {validationErrors.vatNo}
              </Form.Control.Feedback>
            </Form.Group>
          </Col>
        </Row>
      )}
    </>
  );
};

